module.exports = __webpack_public_path__ + "img/banner3.79d327e9.png";